import { PageHeader } from '../components/sections/PageHeader';
import { ProjectGallery } from '../components/sections/ProjectGallery';
import { BeforeAfter } from '../components/sections/BeforeAfter';
import { Industries } from '../components/sections/Industries';
import { ContactCTA } from '../components/sections/ContactCTA';
import { INDUSTRIES } from '../data/siteData';
import { Reveal } from '../hooks/useMotion';

export const ProjectsPage = () => (
  <div data-testid="projects-page">
    <PageHeader eyebrow="Project case studies" title="Built in BIM before it's built on site">
      BIM modeling and Scan-to-BIM work across industrial, electrical and utility facilities. Filter by type and
      click any project to see it full size.
    </PageHeader>

    <section className="sec white">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">BIM modeling</div>
          <h2>Selected models</h2>
        </Reveal>
        <ProjectGallery />
      </div>
    </section>

    <section className="sec">
      <div className="wrap">
        <BeforeAfter />
      </div>
    </section>

    <section className="sec white">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">Industries we serve</div>
          <h2>BIM support tailored to each sector</h2>
          <p>BIM support for diverse project sectors and delivery requirements.</p>
        </Reveal>
        <Industries items={INDUSTRIES} />
      </div>
    </section>

    <ContactCTA />
  </div>
);

export default ProjectsPage;
